import React, { Fragment } from 'react';
import Breadcrumbs from '../../CommonElements/Breadcrumbs';
import DeleteTaskMRT from '../../Component/TasksAO/deleteTaskMRT';

const DeleteTaskMRTT = () => {
    return (
        <Fragment>
            <Breadcrumbs parent="Tasks" title="Delete Tasks" />
            <DeleteTaskMRT />
        </Fragment>
    );
};
export default DeleteTaskMRTT;